'use strict';

let projectConfig = window.projectConfig || {};

projectConfig.i18n = projectConfig.i18n || {};

projectConfig.i18n.getLocale = function(id){
	return this.locale[projectConfig.lang()||'cs'][id];
};

projectConfig.i18n.getLocaleVariant = function(id, value) {
	let localeItem = this.getLocale(id);

	let res = '';
	if (value === 1)
		res = localeItem[0];
	else if (value > 1 && value < 5)
		res = localeItem[1];
	else
		res = localeItem[2];

	// console.info(res);
	return res;
};

projectConfig.i18n.locale = [];

projectConfig.i18n.locale['cs'] = [];
projectConfig.i18n.locale['cs']['dateFormat'] = 'd. m. yyyy';
projectConfig.i18n.locale['cs']['czk'] = 'Kč';
projectConfig.i18n.locale['cs']['month-short'] = 'měs.';
projectConfig.i18n.locale['cs']['years'] = ['rok','roky','let'];
projectConfig.i18n.locale['cs']['months'] = ['měsíc','měsíce','měsíců'];
projectConfig.i18n.locale['cs']['tourBusesCount'] = ['typ autobusu','typy autobusů','typů autobusů'];
projectConfig.i18n.locale['cs']['Detail'] = 'Detail';

projectConfig.i18n.locale['en'] = [];
projectConfig.i18n.locale['en']['dateFormat'] = 'm/d/yyyy';
projectConfig.i18n.locale['en']['czk'] = 'CZK';
projectConfig.i18n.locale['en']['month-short'] = 'month';
projectConfig.i18n.locale['en']['years'] = ['year','years','years'];
projectConfig.i18n.locale['en']['months'] = ['month','months','months'];
projectConfig.i18n.locale['en']['tourBusesCount'] = ['bus type','bus types','bus types'];

// export to window
window.projectConfig = projectConfig;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/locale.js